export default "__VITE_ASSET__BhznkOhk__"